<template>
  <div style="height: inherit;">
    <job-status-alert :config="alertconfig"></job-status-alert>
    <router-view :JobData="JobData"></router-view>
  </div>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import JobStatusAlert from '@/components/Sections/JobStatusAlert.vue';
import SRConst from "@/helpers/Constants/SignalRConstants.js";

export default {
  components: { JobStatusAlert },
  name: "ViewJobContainer",
  mixins: [clientAPI],

  data() {
    return {
      JobData: null,
      loading: false,
    };
  },

  created() {
    this.$store.dispatch("JobHub/clearJob");
    this.update();
    this.$store.dispatch("NotificationStore/subscribe", [
      SRConst.EventKeys.JobChange,
      this.notifyChanges
    ]);
  },

  beforeDestroy() {
    this.$store.dispatch("NotificationStore/unsubscribe", [
      SRConst.EventKeys.JobChange,
      this.notifyChanges
    ]);
  },

  methods: {
    notifyChanges(args) {
      if (args && args.jobId == this.$route.params.jobId) {
        this.update();
      }
    },

    update() {
      this.loading = true;
      //this.$store.dispatch("JobHub/clearJob");
      this.getJobById(this.$route.params.jobId)
        .then((response) => {
          this.JobData = response;

          if (this.$route.params.jobId != this.JobData.Id) {
            //console.error("Job ID mismatch, redirecting to correct job.");
            this.$router.replace({ params: { filter: 'my', jobId: this.JobData.Id } });
          } else {
            this.$store.dispatch("JobHub/JobUpdater/UpdateEntireJob", this.JobData);
          }
        })
        .catch((exception) => console.log(exception))
        .finally(() => (this.loading = false));
    },
  },

  computed: {
    alertconfig() {
      if (this.JobData) {
        var statusid = this.JobData.JobStatusId;
        if (statusid > 60) {
          if (statusid === 110) {
            return { color: "error", icon: "mdi-delete-empty", text: "servicesystem.common_objects.commonterms.deleted" }; //TODO: i18n key text
          } else if (statusid === 100) {
            return { color: "disabled", icon: "mdi-briefcase-off", text: "servicesystem.common_objects.commonterms.closed" };
          } else {
            return { color: "quaternary", icon: "mdi-check", text: "servicesystem.common_objects.commonterms.approved" };
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },

  watch: {
    "$route.params.jobId"() {
      this.$store.dispatch("JobHub/clearJob");
      this.update();
    },

    "$route.query.timestamp"() {
      this.$store.dispatch("JobHub/clearJob");
      this.update();
    },
  },
};
</script>

<style lang="scss" scoped></style>